import { render, staticRenderFns } from "./MailtoSupport.vue?vue&type=template&id=2d0e8cea&"
import script from "./MailtoSupport.vue?vue&type=script&lang=js&"
export * from "./MailtoSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports